<template src="../templates/normal_fcont_158.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import PrintButton from '../components/PrintButton'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';
import AppDownloadColorioNenga from '../components/AppDownloadColorioNenga'
import AppDownloadPhotoPlusJp from '../components/AppDownloadPhotoPlusJp'

import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '158',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,PrintButton,
    ReleaseDateForArticle,AppDownloadColorioNenga,AppDownloadPhotoPlusJp
  },
  
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['158-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['158-3']}
      ]
    };
  }
  
};
</script>
<style >
div.upper-h{
  margin-top: 15px;
}

.image-caption{
  font-size: 12px;
  color: #777;
} 
</style>

